import React from 'react';

import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import EditButton from './EditButton';

export const variablesDependingOnType = {
  list: {
    Airlines: 'listAirLines',
    Airports: 'listAirPorts',
    Companies: 'listCarRentals',
    Cities: 'listCities',
    Hotels: 'listHotels',
    BenefitClassCodes: 'listBenefitClassCodes',
    BenefitDivisionCodes: 'listBenefitDivisionCodes',
    BenefitPlanTypes: 'listBenefitPlanTypes',
    BenefitTypesOfCoverage: 'listBenefitTypeOfCoverages',
  },
  create: {
    Airlines: 'createAirLine',
    Airports: 'createAirPort',
    Companies: 'createCarRental',
    Cities: 'createCity',
    Hotels: 'createHotel',
    BenefitClassCodes: 'createBenefitClassCode',
    BenefitDivisionCodes: 'createBenefitDivisionCode',
    BenefitPlanTypes: 'createBenefitPlanType',
    BenefitTypesOfCoverage: 'createBenefitTypeOfCoverage',
  },
  update: {
    Airlines: 'updateAirLine',
    Airports: 'updateAirPort',
    Companies: 'updateCarRental',
    Cities: 'updateCity',
    Hotels: 'updateHotel',
    BenefitClassCodes: 'updateBenefitClassCode',
    BenefitDivisionCodes: 'updateBenefitDivisionCode',
    BenefitPlanTypes: 'updateBenefitPlanType',
    BenefitTypesOfCoverage: 'updateBenefitTypeOfCoverage',
  },
  delete: {
    Airlines: 'deleteAirLine',
    Airports: 'deleteAirPort',
    Companies: 'deleteCarRental',
    Cities: 'deleteCity',
    Hotels: 'deleteHotel',
    BenefitClassCodes: 'deleteBenefitClassCode',
    BenefitDivisionCodes: 'deleteBenefitDivisionCode',
    BenefitPlanTypes: 'deleteBenefitPlanType',
    BenefitTypesOfCoverage: 'deleteBenefitTypeOfCoverage',
  },
  // The four Benefit lists share the generic "Add Name" / "Edit Name" popups
  // (UC RM-1190 6.2), so they have no singular entry — Modal falls back.
  singular: {
    Airlines: 'Airline',
    Airports: 'Airport',
    Companies: 'Company',
    Cities: 'City',
    Hotels: 'Hotel',
  },
  display: {
    Airlines: 'Airlines',
    Airports: 'Airports',
    Companies: 'Car Rental Companies',
    Cities: 'Cities',
    Hotels: 'Hotels',
    BenefitClassCodes: 'Benefit Class Code',
    BenefitDivisionCodes: 'Benefit Division Code',
    BenefitPlanTypes: 'Benefit Plan Types',
    BenefitTypesOfCoverage: 'Benefit Types of Coverage',
  },
};

export const columnClassName = 'align-middle text-nowrap';

export const commonColumns = [
  {
    Header: 'Name',
    accessor: 'name',
    className: columnClassName,
    Cell: ({ value }) => value && value.charAt(0).toUpperCase() + value.slice(1),
  },
  {
    Header: 'Status',
    accessor: 'status',
    className: columnClassName,
    Cell: ({ value }) => value && value.charAt(0).toUpperCase() + value.slice(1),
  },
];

export const buildColumns = ({ hasState, hasId, setOpenEditModal }) => {
  let newColumns = commonColumns;
  if (hasState) {
    newColumns = [
      commonColumns[0],
      { Header: 'State', accessor: 'state.name', className: columnClassName },
      commonColumns[1],
    ];
  } else if (hasId) {
    newColumns = [
      {
        Header: 'ID',
        accessor: 'id',
        className: columnClassName,
        Cell: ({ value }) => (value.length > 3 ? value.substring(0, 8).concat('...') : value),
      },
      commonColumns[0],
      commonColumns[1],
    ];
  }
  newColumns = [
    ...newColumns,
    {
      Header: '',
      accessor: 'editExpense',
      className: columnClassName,
      Cell: instance => EditButton(instance, setOpenEditModal),
    },
  ];
  return newColumns;
};

export const getSortIcon = (isSorted, isSortedDesc) => {
  let iconProp = faSort;
  if (isSorted) {
    iconProp = isSortedDesc ? faSortDown : faSortUp;
  }
  return <FontAwesomeIcon icon={iconProp} className="ml-1 fa-sm" />;
};
